var styleDataHash = '8fb7168c';  
export const injectCss = (() => {
  var css = `.Ywduh{display:flex;justify-content:center}[dir] .Ywduh{box-shadow:0 0 18px rgba(0,6,36,.1),0 6px 6px rgba(0,6,36,.05);margin-bottom:12px}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "colorPicker": "Ywduh"
};